<template>
  <div class="container lnb d_container">
    <div class="contents_wrap">
      <div class="contents list-container">
        <div class="title">서비스이용약관</div>
          <terms-list-component :termsType="`stipulation`"></terms-list-component>
      </div>
    </div>
  </div>
</template>

<script>
import termsUtil from "@/components/terms/termsUtil";
import TermsListComponent from "@/components/terms/TermsListComponent";
export default {
  name: "TermsService",
  mixins: [termsUtil],
  components: {TermsListComponent},
  provide() {
    return {}
  },
  props: {},
  data() {
    return {
      langOption: '',
      languageListOption: []
    }
  },
  created() {
  },
  mounted() {
    this.setLang()
  },
  beforeDestroy() {
  },
  destroyed() {
  },
  computed: {},
  methods: {
    setLang() {
      this.languageListOption = this.languageList.slice()
    },
    movePage(type) {
      this.$router.push(`/terms/stipulation/${type}`);
    },
    setLanguageFilter(idx) {
      if (idx === '') {
        this.setLang()
      } else this.languageListOption = this.languageList.filter(v => v.c_idx === idx)
    }
  },
  watch: {},
}
</script>

<style scoped>

</style>
